import apiClient from "../../axios/apiClient";


export const getChecklistList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_CHECKLIST_LIST_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Checklist`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_CHECKLIST_LIST_FULFILLED",
        payload: response.data?.data,
        count: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_CHECKLIST_LIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveChecklistData = (token, data) => async (dispatch) => {
    try {
      console.log('token, data', token, data);
      dispatch({ type: "ADD_CHECKLIST_PENDING" });
  
      const response = await apiClient.post(
        `/api/admin/v1/Add-Checklist`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_CHECKLIST_FULFILLED", payload: response.data });
    } catch (error) {
      //console.log(error.response.data);
      dispatch({ type: "ADD_CHECKLIST_REJECTED", payload: error.response });
    }
  };
  

  export const getChecklistListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_CHECKLIST_LISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Checklist/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_CHECKLIST_LISTBYID_FULFILLED",
        payload: response.data?.data,
        stateCount: response.data?.count,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_CHECKLIST_LISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateChecklistData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "UPDATE_CHECKLIST_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-Checklist/${id}`, // Endpoint URL with vehicle ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_CHECKLIST_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_CHECKLIST_REJECTED", payload: error.response });
  }
};


export const updateChecklistStatusData = (token, id, status) => async (dispatch) => {
  try {
    //console.log('token, data', token, data);
    dispatch({ type: "UPDATE_CHECKLIST_STATUS_PENDING" });
    const data={
      "status":status
    }
    const response = await apiClient.post(
      `/api/admin/v1/Update-Checklist-Status/${id}`, // Endpoint URL with vehicle ID
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_CHECKLIST_STATUS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_CHECKLIST_STATUS_REJECTED", payload: error.response });
  }
};


export const deleteChecklistData = (token, id) => async (dispatch) => {
  try {
    console.log('token, id', token, id);
    dispatch({ type: "DELETE_CHECKLIST_PENDING" });

    const response = await apiClient.delete(
      `/api/admin/v1/Delete-Checklist/${id}`, // Endpoint URL with vehicle ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_CHECKLIST_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_CHECKLIST_REJECTED", payload: error.response });
  }
};